import { cn } from "../../lib/utils";
import {
  BAND_LABEL,
  type JournalBand,
} from "../../domains/journal/journalRank";

/**
 * A journal's SIGAPS band, as its rank letter.
 *
 * ONE mark everywhere it is stated — a square in Juisci mint — so the rank
 * reads as the same thing on the article page's teaser, on that page's detail
 * sheet, and on a cited source in JuisciGPT. `variant` picks the SIZE only:
 * `sm` for the teaser's inline strip, `md` for the same square in the desktop
 * article's grade banner (Figma "grade-banner": radius 6, 15px letter), `lg`
 * beside an impact factor.
 *
 * SIGN-OFF (Menie): the mark is ONE green at every band. The letter carries
 * the rank on its own, and a ramp down to red would read as a verdict on a
 * journal rather than a percentile — a Q4 journal is a lower percentile, not
 * a bad journal. So `band` chooses the letter and never the colour. Do not
 * "fix" this into a scale without asking.
 */
export function JournalBandBadge({
  band,
  variant,
}: {
  band: JournalBand;
  variant: "sm" | "md" | "lg";
}): React.JSX.Element {
  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center justify-center",
        "bg-ds-mint-700 font-dm-sans font-bold text-white",
        variant === "sm"
          ? "size-8 rounded-lg text-sm"
          : variant === "md"
            ? "size-8 rounded-md text-ui-body"
            : "size-11 rounded-lg text-2xl"
      )}
    >
      {BAND_LABEL[band]}
    </span>
  );
}
